export const protectContent = {
  hero: {
    title: 'Protect',
    accent: 'your business',
    subtitle:
      'Always-on cybersecurity for London businesses — antivirus, anti-malware and 24/7 monitoring so threats are stopped before they stop you.',
  },
  whyBusiness: {
    title: 'Why businesses need',
    accent: 'Protect',
    intro:
      'One infected laptop or phishing click can lock files, steal customer data and halt trading. Protect gives your team continuous defence without needing an in-house security department.',
    points: [
      {
        title: 'Ransomware and downtime',
        text: 'Attacks that encrypt drives or take systems offline cost hours of lost work and customer trust. Continuous protection reduces that risk.',
      },
      {
        title: 'Customer and staff data',
        text: 'Phones, laptops and shared PCs hold emails, invoices and personal details. Antivirus and anti-malware help keep that information out of the wrong hands.',
      },
      {
        title: 'Remote and hybrid work',
        text: 'Devices move between office, home and on-site. Businesses need cover that follows every endpoint, not only the shop network.',
      },
      {
        title: 'Compliance and reputation',
        text: 'Clients and insurers expect basic cyber hygiene. A managed Protect plan shows you take security seriously.',
      },
    ],
  },
  services: [
    {
      title: '24/7 cybersecurity',
      text: 'Round-the-clock monitoring and response so suspicious activity is flagged even outside office hours.',
    },
    {
      title: 'Antivirus',
      text: 'Business-grade antivirus on workstations and laptops to block known threats and keep systems healthy.',
    },
    {
      title: 'Anti-malware',
      text: 'Protection against trojans, spyware and other malware that antivirus alone may miss.',
    },
  ],
  includes: [
    'Managed antivirus and anti-malware for business devices',
    '24/7 threat monitoring and alerting',
    'Guidance after a suspected infection or phishing attempt',
    'Setup and ongoing updates for your team',
    'London-based support from SecureFix',
  ],
}
